import axios from "axios";
const REST_API_BASE_URL = 'http://localhost:8080/api/insBooks';
export const AddDoctorSer =(formData) => axios.post(REST_API_BASE_URL,formData);
